/**
 * Component to filter profile lists
 */
import * as React from 'react';
import { Card, Row, Col, Input, Checkbox, Radio, DatePicker } from 'antd';
import '../../css/ProfileFilter.scss';
import Constants from '../common/constants';
import moment from 'moment';
// import service from '../../service/apolloclient.service';
import Auth from '../common/auth';
import { Tasks } from '../common/auth';
import Token from '../common/token';
import strings from '../../eyeguide-localization/profile/strings.profile.list';

const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const genderOptions = [{label: 'Female', value: '0'}, {label: 'Male', value: '1'}, 
                       {label: 'Other', value: '2'}, {label: 'Unspecified', value: '3'}];
const { RangePicker } = DatePicker;

interface IFilterProps {
    notifyChangeFilter: any; 
    form: any;
    showOrg: boolean;
    showNotifs: boolean;
    isOpen: boolean;
    organization: any;
    filterObj: any;
    orgs: any;
}
    
interface IFilterState {
    sportsArr: any;
    orgs: any;
    isOpen: boolean;
    showOrg: boolean;
    showNotifs: boolean;
    showCntrls: boolean;
    filterObj: any;
    focus: boolean;
    showOnlySelOrg: boolean;
    showHealthData: boolean;
    dateByRange: boolean;
}

export default class ProfileFilter extends React.Component<IFilterProps, IFilterState> {
    firstname:      any ;
    middlename:     React.RefObject<Input> ;
    lastname:       React.RefObject<Input> ;
    id:             React.RefObject<Input> ;
    gender:         any ;
    level:          any ;
    notifyEmail:    React.RefObject<Input> ;
    notifyPhone:    React.RefObject<Input> ;
    organization:   React.RefObject<Input> ;
    metaInfoMap: any;

    constructor(props: IFilterProps) {
        super(props); 
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        this.firstname = '';
        this.lastname = React.createRef();
        this.id = React.createRef();
        this.gender = '';
        this.level = '';
        this.organization = React.createRef();
        this.notifyEmail = React.createRef();
        this.notifyPhone = React.createRef();
        this.state = {
            sportsArr: [],
            orgs: [],
            isOpen: false,
            showOrg: false,
            showNotifs: false,
            filterObj: {
                'firstname' : '',
                'lastname'  : '',
                'profileID' : '',
                'gender' : [],
                'level': [],
                'organizationname': [],
                'notifyEmail': '',
                'notifyPhone': '',
                'concussed': '',
                'dateRange': ['', '']
            },
            dateByRange: this.props.filterObj.hasOwnProperty('dateRange') ?
                this.props.filterObj.dateRange[0] !== this.props.filterObj.dateRange[1]
                ? true : false : true,
            showCntrls: false,
            focus: true,
            showOnlySelOrg: Auth.canPerformTask(roleid, Tasks.showOnlySelOrg),
            showHealthData: Auth.canPerformTask(roleid, Tasks.canViewHealthData)
        };
        console.log('showOnlySelOrg', Auth.canPerformTask(roleid, Tasks.showOnlySelOrg));
    }

    async componentDidMount() {
        // let ser = new service();
        // let res: any = await ser.getSubOrganizations(1, storage.getSelectedOrgPrimary());
        this.resetControls();
        console.log('this.props.showOrg', this.props.showOrg);
        this.setState({
            orgs: this.props.orgs,
            isOpen: this.props.isOpen,
            showOrg: this.props.showOrg,
            showNotifs: this.props.showNotifs,
            showCntrls: !this.props.showNotifs,
            filterObj: this.props.filterObj,
            focus: true
        });

        setTimeout(() => {this.firstname.focus() ; }, 1); 
    }

    componentWillReceiveProps(nextProps: any) {
        console.log('next props',  nextProps.filterObj);
        this.setState({
            isOpen: nextProps.isOpen,
            showOrg: nextProps.showOrg,
            showNotifs: nextProps.showNotifs,
            showCntrls: !nextProps.showNotifs,
            filterObj: nextProps.filterObj,
            orgs: nextProps.orgs,
        });
    }

    render() {

        if (this.state.isOpen) {
            this.resetControls();
            this.setState({
                isOpen: false
            });
        }
        let levels = Constants.getLevels();
        console.log('levels', levels);
        // const getFieldDecorator = this.props.form;
        return(
            <div className="ProfileFilter">
        <Card className="filterCard" bordered={false} style={{ margin: '24px 16px' }} >
        <Row className="row">
            <Col xs={1} sm={1} md={2} lg={5} xl={5} />
            <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                <div className="label">
                    <span> {strings.lsFirstName}
                    :</span>
                </div>
            </Col>
            
                <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                    <Input 
                        ref={val => this.firstname = val}
                        defaultValue=""
                        placeholder="e.g. Johnny" 
                        onChange={(val) => this.handleChange(val.target.value, 'firstname')}
                        value={this.state.filterObj.firstname}
                    />
                </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>                   
        </Row>
        <Row className="row">
            <Col xs={1} sm={1} md={2} lg={5} xl={5} />
            <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                <div className="label">
                    <span> {strings.lsMiddleName}
                    :</span>
                </div>
            </Col>
            
                <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                    <Input 
                        defaultValue=""
                        placeholder="e.g. Jack" 
                        onChange={(val) => this.handleChange(val.target.value, 'middlename')}
                        value={this.state.filterObj.middlename}
                    />
                </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>                   
        </Row>
        <Row className="row">
            <Col xs={1} sm={1} md={2} lg={5} xl={5} />
            <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                <div className="label">
                    <span>   {strings.lsLastName} 
                    :</span>
                </div>
            </Col>
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                <Input 
                    placeholder="e.g. Thomas"
                    onChange={(val) => this.handleChange(val.target.value, 'lastname')}
                    value={this.state.filterObj.lastname}
                />
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
        </Row>
        <Row className="row" hidden={!this.state.showCntrls}>
            <Col xs={1} sm={1} md={2} lg={5} xl={5} />
            <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
            <div className="label">{strings.lsIDTxt} :</div></Col>
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
            <Input 
                placeholder="e.g. 12345" 
                onChange={(val) => {console.log('inputchanged', val.target.value);
                                    this.handleChange(val.target.value, 'profileID'); }}
                value={this.state.filterObj.profileID}
            />
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
        </Row>
        <Row className="row" hidden={!this.state.showCntrls}>
            <Col xs={1} sm={1} md={2} lg={5} xl={5} />
            <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
            <div className="label">{strings.lsGenderTxt} :</div></Col>
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                <CheckboxGroup 
                    className="labelFrame"
                    style={{ width: '100%' }} 
                    onChange={(val) => {console.log('val of sports', val);
                                        this.handleChange(val, 'gender'); }}
                    options={genderOptions}   
                    value={this.state.filterObj.gender}
                />
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
        </Row>
        <Row className="row">
            <Col xs={1} sm={1} md={2} lg={5} xl={5} />
            <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
            <div className="label">{'Test Date'} :</div></Col>
            <Col span={12}>
                {this.state.dateByRange ?
                    <RangePicker 
                        onChange={this.handleDateRange}
                        format="MM/DD/YYYY"
                        value={this.state.filterObj.hasOwnProperty('dateRange') 
                            && this.state.filterObj.dateRange[0] !== '' ?
                            [moment(this.state.filterObj.dateRange[0]), moment(this.state.filterObj.dateRange[1])] 
                            : []}
                    /> :
                    <DatePicker 
                        onChange={this.handleDateRange}
                        format="MM/DD/YYYY"
                        value={this.state.filterObj.hasOwnProperty('dateRange') 
                            && this.state.filterObj.dateRange[0] !== '' ?
                            moment(this.state.filterObj.dateRange[0])
                            : undefined}
                    />
                }
                &nbsp;&nbsp;
                <Checkbox
                    onChange={e => this.setState({ dateByRange: !e.target.checked })}
                    checked={!this.state.dateByRange}
                >One day
                </Checkbox>
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
        </Row>
        { this.state.showCntrls ? <Row className="row" hidden={this.state.showNotifs}>
            <Col xs={1} sm={1} md={2} lg={5} xl={5} />
            <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
            <div className="label">{strings.lsLevelTxt} :</div></Col>
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
            <CheckboxGroup 
                className="labelFrame"
                style={{ width: '100%' }} 
                onChange={(val) => {console.log('val of sports', val);
                                    this.handleChange(val, 'level'); }}
                value={this.state.filterObj.level} 
            >
                <Row>
                    {levels.map(x => <Col key={x} span={11}>
                    <Checkbox 
                        value={x} 
                        key={x}
                    >
                    {x}                  
                    </Checkbox></Col>)}
                </Row>
            </CheckboxGroup>
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row> : ''}
       {this.state.showOrg && !this.state.showOnlySelOrg && this.state.orgs.length > 0 ? <Row className="row" >
            <Col xs={1} sm={1} md={2} lg={5} xl={5} />
            <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
            <div className="label">{strings.lsOrgTxt} :</div></Col>
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
            <CheckboxGroup 
                className="labelFrame"
                style={{ width: '100%' }} 
                onChange={(val) => {console.log('val of orgs', val);
                                    this.handleChange(val, 'organizationname'); }}
                value={this.state.filterObj.organizationname} 
            >
                <Row>
                    {this.state.orgs.map(x => <Col key={x} span={12}>
                    <Checkbox 
                        className="hyphenate"
                        value={x} 
                        key={x}     
                    >
                    {x}                  
                    </Checkbox></Col>)}
                </Row>
            </CheckboxGroup>
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
        </Row> : ''}
        {/* {this.state.showHealthData ? 
        <Row className="row" hidden={!this.state.showCntrls}>
            <Col xs={1} sm={1} md={1} lg={5} xl={5} />
            <Col xs={8} sm={8} md={6} lg={3} xl={3} className="labelFrame">
            <div className="label">{strings.lsConcussionTxt} :</div></Col>
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
            <RadioGroup 
                className="labelFrame" 
                value={this.state.filterObj.concussed} 
                onChange={(val) => this.handleChange(val.target.value, 'concussed')}
            >
                <Radio defaultChecked={false} value={0}>{Constants.getConcussionFilterValue()[0]}</Radio>
                <Radio defaultChecked={false} value={1}>{Constants.getConcussionFilterValue()[1]}</Radio>
                <Radio defaultChecked={false} value={2}>{Constants.getConcussionFilterValue()[2]}</Radio>
            </RadioGroup>
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
        </Row>
        : ''} */}
        <Row className="row" hidden={!this.state.showNotifs}>
            <Col xs={1} sm={1} md={2} lg={5} xl={5} />
            <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
            <div className="label">{strings.lsNotifyEmailTxt} :</div></Col>
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
            <RadioGroup 
                className="labelFrame" 
                onChange={(val) => this.handleChange(val.target.value, 'notifyEmail')}
                value={this.state.filterObj.notifyEmail} 
            >
                <Radio defaultChecked={false} value={1}>{Constants.getNotifyFilterType()[1]}</Radio>
                <Radio defaultChecked={false} value={0}>{Constants.getNotifyFilterType()[0]}</Radio>
                <Radio defaultChecked={false} value={2}>{Constants.getNotifyFilterType()[2]}</Radio>
            </RadioGroup>
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
        </Row>
        <Row className="row" hidden={!this.state.showNotifs}>
            <Col xs={1} sm={1} md={1} lg={5} xl={5} />
            <Col xs={8} sm={8} md={6} lg={3} xl={3} className="labelFrame">
            <div className="label">{strings.lsNotifyPhonesTxt} :</div></Col>
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
            <RadioGroup  
                className="labelFrame" 
                onChange={(val) => this.handleChange(val.target.value, 'notifyPhone')}
                value={this.state.filterObj.notifyPhone} 
            >
                <Radio defaultChecked={false} value={1}>{Constants.getNotifyFilterType()[1]}</Radio>
                <Radio defaultChecked={false} value={0}>{Constants.getNotifyFilterType()[0]}</Radio>
                <Radio defaultChecked={false} value={2}>{Constants.getNotifyFilterType()[2]}</Radio>
            </RadioGroup>
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
        </Row>
    </Card>
    </div>
        );
    }

    private handleDateRange = (date: any, dateString: any) => {
        console.log('date range', dateString);
        // let filterObj = {...this.state.filterObj};
        // filterObj.dateRange = dateString;
        if (Array.isArray(dateString)) {
            this.handleChange(dateString, 'dateRange');
        } else {
            this.handleChange([dateString, dateString], 'dateRange');
        }
    }

    private handleChange(e: any, prop: string) {
        console.log('handleChange', e);
        if (!(e instanceof Array) && e.toString().trim().length === 0) {
            e = '';
        }
        let filterObj = this.state.filterObj;
        filterObj[prop] = e;
        this.setState({
            filterObj: filterObj
        });
        this.props.notifyChangeFilter(this.state.filterObj);
    }

    // private initializeFilter(): Array<any> {
    //     let filterObj: any = {};
    //     filterObj = {
    //         'firstname' : '',
    //         'middlename' : '',
    //         'lastname'  : '',
    //         'profileID' : '',
    //         'gender' : [],
    //         'level': [],
    //         'organizationname': [],
    //         'notifyEmail': '',
    //         'notifyPhone': '',
    //         'concussed': ''
    //     };
    //     return filterObj;
    // }

    /**
     * Reset all control values
     */
    private resetControls() {
        this.firstname = '';
        this.middlename = React.createRef();
        this.lastname = React.createRef();
        this.id = React.createRef();
         // this.level = '';
        this.notifyEmail = React.createRef();
        this.notifyPhone = React.createRef();
        
    }

}


// WEBPACK FOOTER //
// ./src/components/profile/ProfileFilter.tsx